<template>
  <div v-if="showComponent && onReady" class="ks-infinite-list-container">
    <transition name="fade">
      <div class="ks-infinite-list-loading" v-show="loading">
        <span class="fa fa-spinner fa-spin"></span>
        Loading
      </div>
    </transition>
    <div
      :class="{ 'list-group': type === 'default' }"
      :id="`ks-infinite-list-${_uid}`"
      :style="{ 'overflow-x': overflowX, 'overflow-y': 'auto', height: height ? height : '100vh' }"
      @scroll="$emit('onScroll', $event)"
      @mousedown="$emit('onMousedown', $event)"
    >
      <template v-if="cacheList.length > 0">
        <div
          v-for="(row, idxRow) in list"
          :key="'row' + idxRow"
          :class="{ 'list-group-item': type === 'default' }"
          @click.prevent="setSelected(row, idxRow)"
          @mouseover="setHoverState(row, true)"
          @mouseleave="setHoverState(row, false)"
        >
          <slot name="item" :row="row" :index="idxRow"></slot>
        </div>
      </template>
      <template v-else>
        <slot name="noRecords"></slot>
      </template>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import checkPermissions from '../../mixins/checkPermissions';
  import onMountedDataProvider from '../../mixins/onMountedDataProvider';
  export default {
    /**
      tag
      name: ks-infinite-scroll-list
      description: infinite scroll list
  **/
    name: 'infinite-scroll-list',
    mixins: [checkPermissions, onMountedDataProvider],
    props: {
      /**
          attribute
          name: dataProvider 
          description: dataProvider
      **/
      dataProvider: {
        required: true,
        default: null,
      },
      /**
          attribute
          name: type 
          description: type
      **/
      type: {
        type: String,
        default: 'default',
      },
      /**
          attribute
          name: height 
          description: height
      **/
      height: {
        type: String,
        default: null,
      },
      /**
          attribute
          name: reverse 
          description: reverse
      **/
      reverse: {
        type: Boolean,
        default: false,
      },
      /**
          attribute
          name: loadDelay 
          description: loadDelay
      **/
      loadDelay: {
        type: Number,
        default: 0,
      },
      overflowX: {
        type: String,
        default: 'auto',
      },
    },
    data() {
      return {
        infiniteList: null,
        cacheList: [],
        oldHeight: 0,
        //default
        loading: false,
      };
    },
    watch: {
      cacheList: function (newList, oldList) {
        if (this.reverse && newList.length > oldList.length) {
          setTimeout(() => {
            this.infiniteList.scrollTop = this.infiniteList.scrollHeight - this.oldHeight;
          }, 50);
        }
      },
      'data_provider_ref.list': {
        handler: function (newList, oldList) {
          setTimeout(() => {
            if (typeof newList !== 'undefined' && newList !== null) {
              if (this.cacheList.length == 0) {
                this.cacheList = newList;
              } else if (JSON.stringify(newList) !== JSON.stringify(oldList)) {
                this.cacheList = this.cacheList.concat(newList);
              }
            }
            setTimeout(() => {
              this.loading = false;
            }, 200);
          }, this.loadDelay);
        },
        deep: true,
      },
    },
    computed: {
      list() {
        return this.reverse ? this.cacheList.slice().reverse() : this.cacheList;
      },
    },
    async mounted() {
      //define provider ref
      await this.onMountedDataProvider();
      // Detect when scrolled to bottom.
      this.infiniteList = document.querySelector(`#ks-infinite-list-${this._uid}`);
      this.infiniteList.addEventListener('scroll', e => {
        if (this.reverse) {
          if (this.infiniteList.scrollTop == 0 && this.cacheList.length > 0) {
            this.nextPage();
          }
        } else {
          if (this.infiniteList.scrollTop + this.infiniteList.clientHeight >= this.infiniteList.scrollHeight) {
            this.nextPage();
          }
        }
      });
      this.$emit('mounted', this);
    },
    methods: {
      async reloadList(loadList = false) {
        try {
          this.cacheList = [];
          this.oldHeight = 0;
          if (this.data_provider_ref) this.data_provider_ref.setPage(0, false);
          if (loadList) await this.data_provider_ref.loadList();
        } catch (err) {
          //console.error('KS-APP: infinite scroll list : ', err);
        }
      },
      nextPage() {
        let page = this.data_provider_ref.getPage();
        if (page + 1 < this.data_provider_ref.totalPages) {
          this.loading = true;
          this.oldHeight = JSON.parse(JSON.stringify(this.infiniteList.scrollHeight));
          this.data_provider_ref.setPage((page += 1), true);
        }
      },
      setHoverState(row, value) {
        Vue.set(row, '__hovered', value);
      },
      setSelected(row, idxRow) {
        //this.data_provider_ref.setSelectedListItemIndex(idxRow, this.data_provider_ref.enableReadRecordOnListIndexChange);
        let foundItem = this.cacheList.find(item => item.__selected);
        if (foundItem) foundItem.__selected = false;
        if (idxRow !== null) Vue.set(row, '__selected', true);
        this.$emit('onRowClick', row);
      },
      moveScrollToTop() {
        if (this.reverse) {
          this.infiniteList.scrollTop = this.infiniteList.scrollHeight;
        } else {
          this.infiniteList.scrollTop = 0;
        }
      },
    },
  };
</script>

<style>
  .ks-infinite-list-container {
    position: relative;
  }
  .list-group {
    border: 2px solid #dce4ec;
    border-radius: 5px;
  }
  .list-group-item {
    margin-top: 1px;
    border-left: none;
    border-right: none;
    border-top: none;
    border-bottom: 2px solid #dce4ec;
  }
  .ks-infinite-list-loading {
    text-align: center;
    position: absolute;
    color: #fff;
    z-index: 9;
    background: #9b9a9c;
    padding: 8px 18px;
    border-radius: 5px;
    left: calc(50% - 45px);
    top: calc(50% - 18px);
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
</style>
